// @flow
import React,{useEffect} from "react";
import { Row, Col, Breadcrumb } from "react-bootstrap";
import {APICore} from "../helpers/api/apiCore";
const api = new APICore();
type BreadcrumbItems = {
  label: string,
  path: string,
  active?: boolean,
};

type PageTitleProps = {
  breadCrumbItems: Array<BreadcrumbItems>,
  title: string,
};

/**
 * PageTitle
 */
const PageTitle = (props: PageTitleProps): React$Element<any> => {
  useEffect(() => {
  // let account = api.getAccount();
  //  document.title = ` ${route}- ${account.business_name}`;
    //alert(isUser);

  }, []);


  return (
    <>
    {props.breadCrumbItems? <Row>
      <Col>
        <div className="page-title-box">
          <div className="breadcrumb-container">
            <Breadcrumb className="pb-0 m-0">
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              {props.breadCrumbItems.map((item, index) => {

                return item.active ? (
                  <Breadcrumb.Item active key={index}>
                    {item.label}
                  </Breadcrumb.Item>
                ) : (
                  <Breadcrumb.Item key={index} href={item.path}>
                    {item.label}
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
          </div>
          <h1 className="page-title">{props.title}</h1>
        </div>
      </Col>
    </Row>:<></> }
    </>
  );
};

export default PageTitle;
